<template>
    <div v-if="loading" class="loading-overlay">
      <div class="loading-container">
        <div class="spinner mt-3"></div>
        <div class="loading-text">Seohan</div>
      </div>
    </div>
    <div class="container-fluid mt-4 py-3">
      
      <div class="">
        <p class="custom-text-h4 font-weight-bold ma-2 text-black">Daily Demand</p>
        <p class="font-weight-bold ml-5 mt-0 text-gray">
          <v-icon icon="mdi-sort-reverse-variant" class="mr-2"></v-icon>Order Management >
          Daily Demand
        </p>
      </div>
      <div class="d-flex justify-content-between ">
        <!-- 왼쪽 정렬 버튼 -->
        <div v-if="isMobisUser">
          <v-btn
        class="mr-2"
        color="info"
        :class="{ 'selected-btn': selectedButton === 'ALL' }"
        @click="resetToAll"
      >
        ALL
      </v-btn>
      <v-btn
        class="mr-2"
        color="success"
        :class="{ 'selected-btn': selectedButton === 'MOBIS AL' }"
        @click="selectedButton = 'MOBIS AL'; getMobisALInfo()"
      >
        MOBIS AL
      </v-btn>
      <v-btn
        color="warning"
        :class="{ 'selected-btn': selectedButton === 'MOBIS GA' }"
        @click="selectedButton = 'MOBIS GA'; getMobisGAInfo()"
      >
        MOBIS GA
      </v-btn>
        </div>
        <div v-else style="visibility: hidden; width: 1px;"></div> <!-- 왼쪽 공간 유지 -->

        <!-- 오른쪽 정렬 버튼 -->
        <div>
          <v-btn
              v-if="selectedView === 'daily'"
              color="green"
              class="mr-2"
              @click="exportToExcel"
            >
              Excel
          </v-btn>
            <v-btn
                :color="selectedView === 'daily' ? 'primary' : 'grey'"
                @click="selectedView = 'daily'; scrollToToday()"
                class="mr-2"
            >
                Daily Production
            </v-btn>
            <v-btn
                :color="selectedView === 'weekly' ? 'primary' : 'grey'"
                @click="selectedView = 'weekly'; fetchWorkOrder2()"
            >
                Weekly Overview
            </v-btn>
        </div>
      </div>





      <!-- ✅ 년월 선택 -->
      <v-card class="pa-4 custom-card" elevation="2" >
        <div class="d-flex align-items-center mb-2 justify-start " style="height: 50px" >
            <!-- <div class="d-flex align-items-center mb-3">
                <span class="ml-2 mr-6 font-weight-bold custom-font">Daily Demand </span> 
            </div> -->
            <div v-if="selectedView === 'daily'" class=" d-flex align-items-center mb-3 justify-start">
                <span class="ml-2 mr-6 font-weight-bold text-muted small">
                    * In past date blue text indicates that actual production meets the planned quantity, while red text indicates a shortage.
                </span>
            </div>
            <div v-if="selectedView === 'weekly'" class=" d-flex align-items-center mb-3 justify-start">
                <span class="ml-2 mr-6 font-weight-bold text-muted small">
                  *This section shows the planned weekly production starting 4 weeks from now, covering a total of 5 weeks
                </span>
            </div>

            <v-col v-if="selectedView === 'daily'" cols="8" class="d-flex  ml-auto mt-2 justify-end" style="max-width: 500px;">
              <div class="d-flex ">
                  <div class="container-input3">
                      <span >Select Date :</span>
                  </div>
                  <vue-datepicker class="bg-white h-50" 
                      size="small"
                      v-model="date1" 
                      placeholder="Start Typing ..."
                      :text-input="textInputOptions" 
                      :is-24="false" 
                      :enable-time-picker="false"
                      arrow-navigation
                      :auto-apply="true" 
                      :max-date= computedMaxDate
                      >
                  </vue-datepicker>
              </div>
          </v-col>

        </div>
        <hr class="section-divider" />
        <!-- ✅ 데이터 테이블 -->
        <v-data-table
            v-if="selectedView === 'daily'"
            :items="items"
            :items-per-page = "-1"
            style="height: 85%;"
            class="elevation-1"
            density="compact"
            :hide-default-footer="true"
        >
        <template v-slot:bottom> </template>
        <template #headers>
          <tr>
            <th rowspan="2" class="sticky-header" style = "font-size: 18px;">Part Number</th>
            <th rowspan="2" class="sticky-header" style = "font-size: 18px;">Part Name</th>
            
            <th v-for="date in searchDateList" 
                :key="`header-${date}`"
                :colspan="date < todayStr ? 2 : 1"  
                class="sticky-header"
                :style="getHeaderStyle(date)"

            >
              {{ formatHeaderDate(date) }}
            </th>
          </tr>
          <tr>
            <template v-for="date in searchDateList" :key="`subheader-${date}`">
              <th class="sticky-header" :style="getSubHeaderStyle(date, false)">Plan</th>
              <th v-if="date < todayStr" class="sticky-header" :style="getSubHeaderStyle(date, true)">Work</th>  <!-- 과거만 Work 표시 -->
            </template>
          </tr>
        </template>
        <template #item="{ item }">
            <tr>
                <td class="bold-text align-right">{{ item.partNumber }}</td>
                <td class="bold-text align-right">{{ item.name }}</td>
                <template v-for="date in searchDateList" :key="`data-${date}`">
                    <!-- ✅ 날짜 포맷 변경 (YYYYMMDD → YYYY-MM-DD) -->
                    <td class="bold-text align-right" :style="getFuturePlanColorStyle()">
                        {{
                          formatNumber(
                            (item.dailyData || {})[
                                `${date.slice(0, 4)}-${date.slice(4, 6)}-${date.slice(6, 8)}`
                            ]?.plan || 0
                          )
                        }}
                    </td>

                    <!-- ✅ 과거 날짜만 Work 컬럼 표시 -->
                    <td v-if="date < todayStr" 
                        class="bold-text align-right"
                        :style="getTextColorStyle(
                         
                          (item.dailyData || {})[`${date.slice(0, 4)}-${date.slice(4, 6)}-${date.slice(6, 8)}`]?.plan || 0,
                          (item.dailyData || {})[`${date.slice(0, 4)}-${date.slice(4, 6)}-${date.slice(6, 8)}`]?.work || 0
                        
                        )"
                    >
                        {{
                          formatNumber(
                            (item.dailyData || {})[`${date.slice(0, 4)}-${date.slice(4, 6)}-${date.slice(6, 8)}`]?.work || 0
                        )
                        }}
                    </td>
                </template>
            </tr>
        </template>




        </v-data-table>
        <v-data-table
            v-if="selectedView === 'weekly'"
            :items="weeklyItems"
            :items-per-page="-1"
            style="height: 85%;"
            class="elevation-1"
            density="compact"
            :hide-default-footer="true"
        >
        <template v-slot:bottom> </template>
        <template #headers>
            <tr>
                <th rowspan="2" class="sticky-header part_number_header" style = "font-size: 18px;">Part Number</th>
                <th rowspan="2" class="sticky-header" style = "font-size: 18px;">Part Name</th>
                <th
                    v-for="date in weeklyDates"
                    :key="date"
                    colspan="1"
                    class="sticky-header"
                    v-html="getWeekRange(date)"
                ></th>
            </tr>
            <tr>
                <template v-for="date in weeklyDates" :key="`weekly-sub-${date}`">
                    <th class="sticky-header">Plan</th>
                </template>
            </tr>
        </template>

        <template #item="{ item }">
          <tr>
              <td>{{ item.partNumber }}</td>
              <td>{{ item.name }}</td>
              <template v-for="date in weeklyDates" :key="`weekly-data-${date}`">
                  <td class="text-right font-weight-bold">
                      {{ 
                        formatNumber( 
                          (item.weeklyData || {})[`${date.slice(0, 4)}-${date.slice(4, 6)}-${date.slice(6, 8)}`]?.plan || 0 
                      )  
                        }}
                      
                  </td>
              </template>
          </tr>
      </template>

    </v-data-table>

        </v-card>
    </div>
  </template>
  
  <script>
  import axios from "axios";
  import { mapState } from "vuex";
  import "@vuepic/vue-datepicker/dist/main.css";
  import VueDatepicker from "@vuepic/vue-datepicker";
  export default {
    components: {
            VueDatepicker,
        },
    data() {
      return {
        ALitem: [],
        GAitem: [],
        searchDateList: [],
        date1: new Date(),  // 시작 날짜 (기본값: 오늘)
        date2: new Date(),  // 종료 날짜 (기본값: 오늘)
        textInputOptions: {
            format: 'yyyy-MM-dd', // 날짜 포맷
            inputClass: 'custom-datepicker-input'
        },
        search: {
          date: new Date().toISOString().split("T")[0],  // ✅ 오늘 날짜 기본값
        },
        selectedDate: new Date(),  // ✅ 선택한 날짜 저장 (YYYY-MM-DD 형식)
        maxDate: "",  // ✅ 최대 선택 가능 날짜
        maxDate2: "",
        selectedView: 'daily',
        selectedYearMonth: "", // 선택된 년월
        yearMonthOptions: [], // 보여줄 년월 리스트
        items: [],
        originalItems: [],
        weeklyItems: [],
        loading: false,
        selectedButton: 'ALL', 
        mobisUserList: [],
      };
    },
  
    computed: {
      isMobisUser() {
        return this.mobisUserList
          .map(code => String(code).toLowerCase())
          .includes(String(this.username || "").toLowerCase());
      },
      computedMaxDate() {
        return this.maxDate2;
      },
      todayStr() {
        return new Date().toISOString().split("T")[0].replace(/-/g, "");
      },
      filteredDates() {
        return this.searchDateList.map(date => date.replace(/-/g, ""));
      },

      // ✅ 날짜를 YYYY/MM/DD 형태로 변환 (헤더에 표시할 형식)
      formatDate() {
        return (date) => {
          return `${date.slice(0, 4)}/${date.slice(4, 6)}/${date.slice(6, 8)}`;
        };
      },
      ...mapState({
        username: (state) => state.username,
        userName: (state) => state.userName
      }),
      daysInMonth() {
        if (!this.selectedYearMonth) return [];
        const [year, month] = this.selectedYearMonth.split("-").map(Number);
        const daysInMonth = new Date(year, month, 0).getDate();
        const days = [];

        for (let day = 1; day <= daysInMonth; day++) {
        const date = new Date(year, month - 1, day);
        const isWeekend = date.getDay() === 0 || date.getDay() === 6; // 일(0), 토(6)
        days.push({ day, isWeekend });
        }
        return days;
      },
      weeklyDates() {
        const today = new Date();
        const weeks = [];
        
        // 현재 날짜 기준으로 다음 월요일 찾기
        let currentDate = new Date(today);
        const dayOfWeek = currentDate.getDay(); // 현재 요일 (0: 일요일, 1: 월요일, ..., 6: 토요일)

        // 이번 주 월요일을 찾음
        if (dayOfWeek !== 1) { 
            currentDate.setDate(currentDate.getDate() + (1 - dayOfWeek + 7) % 7); // 다음 월요일로 이동
        }

        // 4주 차 ~ 8주 차까지의 월요일만 추가
        for (let i = 4; i <= 15; i++) {
            let futureMonday = new Date(currentDate);
            futureMonday.setDate(currentDate.getDate() + (i - 1) * 7); // i주 뒤의 월요일
            weeks.push(futureMonday.toISOString().split("T")[0].replace(/-/g, ""));
        }

        return weeks;
    }

    },
  
    created() {
      this.generateYearMonthOptions();
      this.setMaxDate();  // ✅ 페이지 로드 시 maxDate 설정
      this.setTodayAsDefault();  // ✅ 페이지 로드 시 오늘 날짜 자동 선택

    },
    async mounted() {
      await this.fetchMobisUserList();

      this.setMaxDate();
      this.updateSearchDateList();
      this.fetchWorkOrder();
    },
    watch: {
        selectedYearMonth() {
          this.fetchWorkOrder();
        },
        date1(newValue) {
          //console.log("📌 선택한 날짜:", newValue);
          if(newValue != null){
           this.updateSearchDateList();
           this.fetchWorkOrder();
          }  // ✅ 날짜 변경 시 업데이트
        },
    },

  
    methods: {
      async fetchMobisUserList() {
        try {
          const res = await axios.get("/api/getGaAlCompany");
          this.mobisUserList = (res.data.result || [])
            .map(item => String(item.ASDES || item).trim())
            .filter(Boolean);
        } catch (error) {
          console.error("❌ getGaAlCompany API 호출 오류:", error);
          this.mobisUserList = [];
        }
      },
      formatHeaderDate(date) {
        const y = date.slice(0,4)
        const m = date.slice(4,6)
        const d = date.slice(6,8)

        return `${m}/${d}/${y}`
      },
      async exportToExcel() {
        this.loading = true;
        try {
          // 1) 일(daily) 날짜 분리
          const today = new Date().toISOString().split("T")[0].replace(/-/g, "");
          const pastDates   = (this.searchDateList || []).filter(d => d <  today);
          const futureDates = (this.searchDateList || []).filter(d => d >= today);

          // 2) 주간(weekly) 공통 데이터 생성
          await this.fetchWorkOrder2(); // this.weeklyItems, this.weeklyDates, this.originalWeeklyData 채움

          // 날짜 "YYYYMMDD" → "YYYY-MM-DD" + sort
          const weeklyDatesSorted = [...(this.weeklyDates || [])]
            .map(d => {
              const s = String(d);
              return `${s.slice(0,4)}-${s.slice(4,6)}-${s.slice(6,8)}`;
            })
            .sort();

          // 기본 weeklyItemsPayload(ALL): [{partNumber,name,plans:number[]}]
          const weeklyItemsPayload = (this.weeklyItems || []).map(it => {
            const plans = weeklyDatesSorted.map(d => {
              const v = it.weeklyData?.[d]?.plan;
              return Number.isFinite(Number(v)) ? Number(v) : 0;
            });
            return { partNumber: it.partNumber || "", name: it.name || "", plans };
          });

          // 3) MOBIS 전용: AL/GA 주간 데이터도 POST로 호출해서 함께 보내기
          let response;

          if (this.isMobisUser) {
            // Daily 최신화(선택)
            await Promise.all([this.getMobisALInfo(), this.getMobisGAInfo(), this.fetchWorkOrder()]);

            // 주간 API에 보낼 최소 payload: partNumbers + weeklyDates
            const partNumbers = (this.originalWeeklyData || []).map(x => x.partNumber);
            this.loading = true;

            // ➕ AL/GA 주간 API 동시 호출 (POST + body)
            const [alW, gaW] = await Promise.all([
              axios.post("/api/getMobieALWeeklyInfomation", {
                username: this.username,
                weeklyDates: this.weeklyDates,     // ["YYYYMMDD", ...]
                partNumbers,                       // ["51710-N9100", ...]
              }),
              axios.post("/api/getMobieGAWeeklyInfomation", {
                username: this.username,
                weeklyDates: this.weeklyDates,
                partNumbers,
              }),
            ]);

            // 응답 weeklyOrders → [{partNumber,name,plans[]}]
            const toPayload = (weeklyOrders) => {
              return (weeklyOrders || []).map((wo) => {
                // 응답 키가 YYYYMMDD라면 ISO 변환 lookup
                const mapByIso = {};
                Object.keys(wo.weeklyData || {}).forEach(k => {
                  const s = String(k);
                  const iso = s.includes("-") ? s : `${s.slice(0,4)}-${s.slice(4,6)}-${s.slice(6,8)}`;
                  mapByIso[iso] = wo.weeklyData[k];
                });
                const plans = weeklyDatesSorted.map(d => Number(mapByIso?.[d]?.plan ?? 0));
                return { partNumber: wo.CITEM || wo.partNumber || "", name: wo.name || "", plans };
              });
            };

            const ALweeklyItemsPayload = alW.data?.weeklyOrders ? toPayload(alW.data.weeklyOrders) : [];
            const GAweeklyItemsPayload = gaW.data?.weeklyOrders ? toPayload(gaW.data.weeklyOrders) : [];

            // // 📤 엑셀 생성 요청 (MOBIS)
            // response = await axios.post(
            //   "/api/exportDailyExcelMobis",
            //   {
            //     username: this.username,
            //     pastDates,
            //     futureDates,
            //     item: this.originalItems,      // Daily 통합
            //     ALitem: this.ALitem,   // Daily AL
            //     GAitem: this.GAitem,   // Daily GA

            //     // 🔹 주간(ALL)
            //     weeklyItems: weeklyItemsPayload,
            //     weeklyDates: weeklyDatesSorted,

            //     // 🔹 주간(MOBIS) AL/GA 세부
            //     ALweeklyItems: ALweeklyItemsPayload,
            //     GAweeklyItems: GAweeklyItemsPayload,
            //   },
            //   { responseType: "blob" }
            // );
            const exportUrl = "/api/exportDailyExcelMobisMando"

              

            response = await axios.post(
              exportUrl,
              {
                username: this.username,
                pastDates,
                futureDates,
                item: this.originalItems,
                ALitem: this.ALitem,
                GAitem: this.GAitem,
                weeklyItems: weeklyItemsPayload,
                weeklyDates: weeklyDatesSorted,
                ALweeklyItems: ALweeklyItemsPayload,
                GAweeklyItems: GAweeklyItemsPayload,
              },
              { responseType: "blob" }
            );
          } else {
            // 일반 사용자: Daily + Weekly(ALL)
            response = await axios.post(
              "/api/exportDailyExcel",
              {
                username: this.username,
                pastDates,
                futureDates,
                item: this.originalItems,
                weeklyItems: weeklyItemsPayload,
                weeklyDates: weeklyDatesSorted,
              },
              { responseType: "blob" }
            );
          }

          // 4) 다운로드
          const blob = new Blob(
            [response.data],
            { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }
          );
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = `DailyDemand_${this.username}_${new Date().toISOString().split("T")[0]}.xlsx`;
          link.click();
          window.URL.revokeObjectURL(link.href);
          
        } catch (error) {
          console.error("❌ Excel export API 오류:", error);
          alert("엑셀 다운로드 중 오류가 발생했습니다.");
        } finally {
          this.selectedButton = 'ALL';
          await this.fetchWorkOrder();
          this.loading = false;

        }
      },

      formatNumber(value) {
        if (!value) return "0"; // 값이 없으면 0 반환
        return new Intl.NumberFormat().format(value);
    },
      getFuturePlanColorStyle() {
        return 'color: #000000; font-weight: bold;';  // 👉 여기서 색상 선택!
    },
      getTextColorStyle(plan, work) {
        if (work >= plan) {
            return 'color: #4A90E2; font-weight: bold;';  // ✅ work >= plan → 파란색 글씨
        } else {
            return 'color: red; font-weight: bold;';  // ✅ work < plan → 빨간색 글씨
        }
    },
      getHeaderStyle(date) {
        const dayOfWeek = new Date(
          `${date.slice(0, 4)}-${date.slice(4, 6)}-${date.slice(6, 8)}`
        ).getDay(); // 0(일) ~ 6(토)

        // ✅ 주말(토/일)일 경우 빨간색 배경 적용
        if (dayOfWeek === 6 || dayOfWeek === 5) {
          return "color: red; font-weight: bold;"; // 연한 빨간색
        }
        return "background-color: #ffff; font-weight: bold;"; // 기본 파란 계열
      },

      getSubHeaderStyle(date, isWorkColumn = false) {
        // ✅ Work 칸은 얕은 회색 배경 적용
        if (isWorkColumn) {
          return " font-weight: bold;";
        }
        return "";
      },
      getCellStyle(date, isWorkColumn = false) {
        const dayOfWeek = new Date(
          `${date.slice(0, 4)}-${date.slice(4, 6)}-${date.slice(6, 8)}`
        ).getDay(); // 0(일) ~ 6(토)

        // ✅ 주말(토/일)일 경우 빨간색 배경 적용
        if (dayOfWeek === 0 || dayOfWeek === 6) {
          return "background-color: #ffcccc; font-weight: bold;"; // 연한 빨간색
        }

        // ✅ Work 칸은 얕은 회색 배경 적용
        if (isWorkColumn) {
          return "background-color: #f0f0f0; font-weight: bold;";
        }

        return "";
      },

      isEvenColumn(index) {
        return index % 2 === 0;
      },
      updateSearchDateList() {
        this.searchDateList = []; // 초기화
        let startDate = new Date(this.date1);  // ✅ 사용자가 선택한 날짜
        let maxDate = new Date(this.maxDate); // ✅ 최대 날짜

        for (let i = 0; i <= 30; i++) {  // ✅ 0부터 시작해서 오늘 날짜 포함
          let newDate = new Date(startDate);
          newDate.setDate(newDate.getDate() + i);

          this.searchDateList.push(newDate.toISOString().split("T")[0].replace(/-/g, "")); // YYYYMMDD 형식

          if (newDate >= maxDate) break;  // ✅ maxDate를 넘기면 추가하고 중단
        }

        //console.log("📌 검색할 날짜 리스트:", this.searchDateList);
      },
      onDateSelect(event) {
        // ✅ 클릭한 날짜를 selectedDate에 적용
        this.selectedDate = event.date;
        //console.log("📌 선택된 날짜:", this.selectedDate);
        this.fetchWorkOrder();
      },
      setMaxDate() {
        const today = new Date();
        const currentDay = today.getDay(); // 0: 일요일, 1: 월요일, ..., 6: 토요일
        const daysUntilNextSunday = (7 - currentDay) % 7; // 다음 일요일까지 남은 일 수
        const weeksToAdd = 3; // 3주 후의 일요일까지 선택 가능

        const maxDate = new Date(today);
        maxDate.setDate(today.getDate() + daysUntilNextSunday + (weeksToAdd * 7));
        this.maxDate2 = maxDate;
        this.maxDate = maxDate.toISOString().split("T")[0];  // ✅ YYYY-MM-DD 형식
        //console.log("맥스 데이트",maxDate)
      },
      onDateChange() {
        //console.log("📌 선택된 날짜:", this.search.date);
        this.fetchWorkOrder();  // ✅ 선택한 날짜로 API 호출
      },
      setTodayAsDefault() {
        this.selectedDate = new Date()
        this.fetchWorkOrder();  // ✅ API 호출
      },

      scrollToToday() {
          this.$nextTick(() => {
              setTimeout(() => {
                  const today = new Date();
                  // ✅ 기존 YYYY-MM-DD → YYYY-MM/DD 로 변경
                  const todayStr = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}/${String(today.getDate()).padStart(2, '0')}`;


                  // ✅ 날짜가 포함된 헤더 찾기
                  const headers = document.querySelectorAll(".v-data-table thead th");

                  let found = false;
                  headers.forEach((header) => {
                      if (header.textContent.includes(todayStr)) {
                          header.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
                          //console.log("✅ 오늘 날짜로 스크롤 이동 완료!");
                          found = true;
                      }
                  });

                  if (!found) {
                      console.warn("⚠ 오늘 날짜를 찾을 수 없습니다. 데이터 확인 필요!");
                  }
              }, 500); // ✅ DOM이 완전히 로드될 시간을 줌
          });
      },
      getWeekRange(dateString) {
        const year = parseInt(dateString.slice(0, 4), 10);
        const month = parseInt(dateString.slice(4, 6), 10) - 1;
        const day = parseInt(dateString.slice(6, 8), 10);

        const startDate = new Date(year, month, day);
        const endDate = new Date(startDate);
        endDate.setDate(startDate.getDate() + 6);

        const y = startDate.getFullYear();
        const m = String(startDate.getMonth() + 1).padStart(2, '0');
        const dStart = String(startDate.getDate()).padStart(2, '0');
        const endM = String(endDate.getMonth() + 1).padStart(2, '0');
        const dEnd = String(endDate.getDate()).padStart(2, '0');

        return `<span class="week-range-header">${y}/${m}/${dStart}~${endM}/${dEnd}</span>`;
      },


      generateYearMonthOptions() {
        const today = new Date();
        const baseYear = today.getFullYear();
        const baseMonth = today.getMonth() + 1; // 1월이 0이니까 +1
  
        const months = [];
        for (let offset = -2; offset <= 1; offset++) {
          const date = new Date(baseYear, baseMonth - 1 + offset);
          const year = date.getFullYear();
          const month = (date.getMonth() + 1).toString().padStart(2, "0");
          months.push(`${year}-${month}`);
        }
  
        this.yearMonthOptions = months;
        this.selectedYearMonth = months[2]; // 기본 선택값은 현재달
      },
      async fetchWorkOrder2() {

        this.selectedButton = 'ALL';
        //console.log("📌 요청할 weeklyDates:", this.weeklyDates);
        try {
            this.loading = true;
            const response = await axios.get("/api/getWeeklyOrder", {
                params: { username: this.username, weeklyDates: this.weeklyDates }
            });

            //console.log("✅ getWeeklyOrder 응답:", response.data);
            
            if (response.data.success) {
                  this.originalWeeklyData = response.data.weeklyOrders.map((workOrder) => {
                    const weeklyData = {};

                    // 📌 날짜 변환 로직 추가
                    Object.keys(workOrder.weeklyData).forEach(date => {
                        const formattedDate = `${date.slice(0, 4)}-${date.slice(4, 6)}-${date.slice(6, 8)}`;
                        weeklyData[formattedDate] = { plan: workOrder.weeklyData[date].plan };
                    });

                    return {
                        partNumber: workOrder.CITEM, // ✅ CITEM 넣기
                        name: workOrder.name, // ✅ 제품명
                        weeklyData, // ✅ 변환된 날짜별 plan 값
                    };
                });

                // ✅ 화면에 표시할 데이터도 원본과 동일하게 설정
                this.weeklyItems = [...this.originalWeeklyData];
                //console.log("✅ 변환된 weeklyItems:", this.weeklyItems);
            } else {
                console.error("❌ 주간 작업 지시서 조회 실패:", response.data.message);
            }
        } catch (error) {
            console.error("❌ fetchWorkOrder2 API 호출 오류:", error);
        } finally {
            this.loading = false;
        }
    },

  
    async fetchWorkOrder() {
        //console.log("📌 전체 날짜 리스트:", this.searchDateList);

        // 📌 오늘 날짜 구하기 (YYYYMMDD 형식)
        const today = new Date().toISOString().split("T")[0].replace(/-/g, "");

        // 📌 날짜 리스트를 두 개로 분할
        const futureDates = this.searchDateList.filter(date => date >= today); // 오늘 이후
        const pastDates = this.searchDateList.filter(date => date < today); // 오늘 포함 이전

        //console.log("📌 오늘 이후 날짜:", futureDates);
        //console.log("📌 오늘 포함 이전 날짜:", pastDates);

        try {
            this.loading = true;

            let pastResult = { data: { success: false, workOrders: [] } };
            let futureResult = { data: { success: false, workOrders: [] } };

            const requests = [];

            // 📌 PastWorkOrder API 호출 (과거 데이터가 있는 경우)
            if (pastDates.length > 0) {
                requests.push(
                    axios.post("/api/getPastWorkOrder", {
                        username: this.username,
                        dates: pastDates, // ✅ pastDates 리스트 전송
                    }).then(response => { pastResult = response; })
                    .catch(error => console.error("❌ getPastWorkOrder API 오류:", error))
                );
            }

            // 📌 FutureWorkOrder API 호출 (미래 데이터가 있는 경우)
            if (futureDates.length > 0) {
                requests.push(
                    axios.post("/api/getFutureWorkOrder", {
                        username: this.username,
                        dates: futureDates, // ✅ futureDates 리스트 전송
                    }).then(response => { futureResult = response; })
                    .catch(error => console.error("❌ getFutureWorkOrder API 오류:", error))
                );
            }

            // 📌 모든 요청 실행
            await Promise.all(requests);

            //console.log("✅ getPastWorkOrder 응답:", pastResult.data);
            //console.log("✅ getFutureWorkOrder 응답:", futureResult.data);

            if (pastResult.data.success || futureResult.data.success) {
            // ✅ 원본 데이터 저장 (과거+미래 데이터 통합 처리)
            const mergedItems = new Map();

            // ✅ 과거 데이터 추가 (plan & work)
            pastResult.data.workOrders.forEach(workOrder => {
                const processedItem = this.processWorkOrder(workOrder, true);
                mergedItems.set(processedItem.partNumber, processedItem);
            });

            // ✅ 미래 데이터 추가 (plan만 있음)
            futureResult.data.workOrders.forEach(workOrder => {
                const processedItem = this.processWorkOrder(workOrder, false);

                if (mergedItems.has(processedItem.partNumber)) {
                    // ✅ 같은 partNumber가 있으면 dailyData 병합
                    const existingItem = mergedItems.get(processedItem.partNumber);
                    
                    Object.keys(processedItem.dailyData).forEach(date => {
                        if (!existingItem.dailyData[date]) {
                            existingItem.dailyData[date] = { plan: 0, work: null };
                        }
                        existingItem.dailyData[date].plan += processedItem.dailyData[date].plan;
                    });

                } else {
                    // ✅ 없는 경우 새로 추가
                    mergedItems.set(processedItem.partNumber, processedItem);
                }
            });

            // ✅ 최종 병합된 데이터 리스트
            this.originalItems = Array.from(mergedItems.values());
            this.items = [...this.originalItems];

            //console.log("✅ 최종 변환된 dailyItems:", this.items);
        } else {
            console.warn("⚠ 데이터가 없습니다. (PastWorkOrder & FutureWorkOrder)");
            this.loading = false;
        }

        } catch (error) {
            console.error("❌ getWorkOrder API 호출 오류:", error);
            this.loading = false;
        } finally {
            this.loading = false;
        }
    },

    // ✅ Plan & Work 데이터 정리 (과거 / 미래 구분)
    processWorkOrder(workOrder, isPast) {
        const dailyData = {};

        Object.keys(workOrder.dailyData).forEach(date => {
            const formattedDate = `${date.slice(0, 4)}-${date.slice(4, 6)}-${date.slice(6, 8)}`;
            dailyData[formattedDate] = {
                plan: workOrder.dailyData[date].plan,
                work: isPast ? workOrder.dailyData[date].work : null, // ✅ 과거만 work 포함
            };
        });

        return {
            partNumber: workOrder.CITEM, // ✅ CITEM (BOM에서 가져온 품번)
            name: workOrder.name, // ✅ 품명
            dailyData, // ✅ 날짜별 plan/work 값
        };
    },
      getWorkStyle(plan, work) {
          if (work >= plan) {
          return ' color: #004085; font-weight: bold;'; // 파란색 배경 + 글씨
          } else {
          return ' color: #721c24; font-weight: bold;'; // 빨간색 배경 + 글씨
          }
      },



      resetToAll() {
          this.selectedButton = 'ALL'; 
          this.items = [...this.originalItems]; // ✅ 원본 데이터를 다시 items에 넣음
          if (this.originalWeeklyData && this.originalWeeklyData.length > 0) {
            this.weeklyItems = [...this.originalWeeklyData];
          }
          //console.log("✅ ALL 버튼 클릭 - items가 원본 데이터로 복원됨:", this.items);
      },

      async getMobisALInfo() {
        try {
          this.loading = true;
          let response;
          if (this.selectedView === 'daily') {
              // ✅ Daily 데이터 API 호출
              response = await axios.post("/api/getMobieALInfomation", {
                  data: this.originalItems,
                  username: this.username,
                  searchDates: this.searchDateList,
              });
          } else if (this.selectedView === 'weekly') {
              // ✅ Weekly 데이터 API 호출
              const partNumbers = [...new Set(
                (this.originalWeeklyData || []).map(x => x.partNumber).filter(Boolean)
              )];

              response = await axios.post("/api/getMobieALWeeklyInfomation", {
                username: this.username,
                weeklyDates: this.weeklyDates, // ["YYYYMMDD", ...]
                partNumbers,                    // ["51710-N9100", ...]
              });
          }

            //console.log("✅ MOBIS AL 응답:", response.data);

            if (response.data.success) {
              if (this.selectedView === 'daily') {
                  // ✅ Daily 데이터 필터링 후 저장
                  const parsedItems = response.data.result.map((workOrder) => {
                    const dailyData = {};
                    Object.keys(workOrder.dailyData).forEach(date => {
                      const formattedDate = `${date.slice(0, 4)}-${date.slice(4, 6)}-${date.slice(6, 8)}`;
                      dailyData[formattedDate] = {
                        plan: workOrder.dailyData[date].plan,
                        work: workOrder.dailyData[date].work,
                      };
                    });

                    return {
                      partNumber: workOrder.CITEM,
                      name: workOrder.name,
                      dailyData,
                    };
                  });
                  this.items = parsedItems;
                  this.ALitem = [...parsedItems]; // ✅ 백엔드 전용 저장
                  //console.log("✅ 필터링된 AL daily items:", this.ALitem);
                  this.loading = false;
                  //console.log("✅ 필터링된 daily items:", this.items);
              } else if (this.selectedView === 'weekly') {
                  // ✅ Weekly 데이터 필터링 후 저장
                  this.originalWeeklyDataAL = response.data.weeklyOrders.map((workOrder) => {
                      const weeklyData = {};

                      Object.keys(workOrder.weeklyData).forEach(date => {
                          const formattedDate = `${date.slice(0, 4)}-${date.slice(4, 6)}-${date.slice(6, 8)}`;
                          weeklyData[formattedDate] = {
                              plan: workOrder.weeklyData[date].plan,
                          };
                      });

                      return {
                          partNumber: workOrder.CITEM, 
                          name: workOrder.name,
                          weeklyData,
                      };
                  });
                  //console.log("✅ 필터링된 weekly items:", this.originalWeeklyDataAL);
                  this.loading = false;
                  this.weeklyItems = [...this.originalWeeklyDataAL]
                  //console.log("✅ 필터링된 weekly items:", this.weeklyItems);
              }
              this.loading = false;
          } else {
              console.error("❌ MOBIS AL 데이터 필터링 실패:", response.data.message);
              this.loading = false;

          }
      } catch (error) {
          console.error("❌ MOBIS AL API 호출 오류:", error);
          this.loading = false;
      }
    },

    async getMobisGAInfo() {

      try {
        //console.log("📌 GA API 호출 - 전달할 searchDateList:", this.searchDateList);
          this.loading=true;
          let response;
          if (this.selectedView === 'daily') {
              // ✅ Daily 데이터 API 호출
              response = await axios.post("/api/getMobieGAInfomation", {
                  data: this.originalItems,
                  username: this.username,
                  searchDates: this.searchDateList,
              });
          } else if (this.selectedView === 'weekly') {
            const partNumbers = [...new Set(
              (this.originalWeeklyData || []).map(x => x.partNumber).filter(Boolean)
            )];

            response = await axios.post("/api/getMobieGAWeeklyInfomation", {
              username: this.username,
              weeklyDates: this.weeklyDates,
              partNumbers,
            });
          }


            //console.log("✅ MOBIS GA 응답:", response.data);

            if (response.data.success) {
              if (this.selectedView === 'daily') {
                  // ✅ Daily 데이터 필터링 후 저장
                  const parsedItems = response.data.result.map((workOrder) => {
                    const dailyData = {};
                    Object.keys(workOrder.dailyData).forEach(date => {
                      const formattedDate = `${date.slice(0, 4)}-${date.slice(4, 6)}-${date.slice(6, 8)}`;
                      dailyData[formattedDate] = {
                        plan: workOrder.dailyData[date].plan,
                        work: workOrder.dailyData[date].work,
                      };
                    });

                    return {
                      partNumber: workOrder.CITEM,
                      name: workOrder.name,
                      dailyData,
                    };
                  });

                  this.items = parsedItems;
                  this.GAitem = [...parsedItems]; // ✅ 백엔드로 넘길용도 따로 저장
                  this.loading = false;
                  //console.log("✅ 필터링된 GA daily items:", this.GAitem);
              } else if (this.selectedView === 'weekly') {
                  // ✅ Weekly 데이터 필터링 후 저장
                  this.originalWeeklyDataGA = response.data.weeklyOrders.map((workOrder) => {
                      const weeklyData = {};

                      Object.keys(workOrder.weeklyData).forEach(date => {
                          const formattedDate = `${date.slice(0, 4)}-${date.slice(4, 6)}-${date.slice(6, 8)}`;
                          weeklyData[formattedDate] = {
                              plan: workOrder.weeklyData[date].plan,
                          };
                      });

                      return {
                          partNumber: workOrder.CITEM, 
                          name: workOrder.name,
                          weeklyData,
                      };
                  });
                  //console.log("✅ 필터링된 weekly items:", this.originalWeeklyDataGA);

                  this.weeklyItems = [...this.originalWeeklyDataGA]
                  //console.log("✅ 필터링된 weekly items:", this.weeklyItems);
                  this.loading = false;
              }
          } else {
              console.error("❌ MOBIS AL 데이터 필터링 실패:", response.data.message);
              this.loading = false;
          }
      } catch (error) {
          console.error("❌ MOBIS AL API 호출 오류:", error);
          this.loading = false;
      }
    },

    },
  };
  </script>
  
  
  <style scoped>



    :deep() .v-data-table th {
    padding: 10px 15px;
    min-width: 10px;
    height: 40px;
    }

    :deep() .v-data-table td {
    padding: 10px 15px;
    font-size: 12px;
    min-width: 60px;
    height: 40px;
    }
  .custom-width {
    max-width: 300px;
  }
  .custom-bg ::v-deep(.v-input__control) {
    background-color: rgb(255, 255, 255) !important;
  }
  .custom-min-height {
    min-height: 400px;
  }
  .vertical-align {
    vertical-align: middle;
  }

  .data-table-row:hover {
    background-color: #f5f5f5;
    cursor: pointer;
  }



  :deep() .v-data-table thead th {
  position: sticky;
  top: 0;
  z-index: 5;
}
/* ✅ 두 번째 헤더줄 (계획/실적)도 상단 고정 */
:deep() .v-data-table thead tr:nth-child(2) th {
  top: 40px; /* 첫 번째 헤더 높이만큼 내려줌 */
  z-index: 4;
}


/* 품번리스트*/
:deep() .v-data-table th:nth-child(1),
:deep() .v-data-table td:nth-child(1) {
  position: sticky;
  left: 0;
  z-index: 30;
  background-color: rgb(255, 255, 255);
  align-items: center;

  align-items: center;
  text-align: center;
  font-weight: bold;
}
/* 이름름리스트*/
:deep() .v-data-table th:nth-child(2),
:deep() .v-data-table td:nth-child(2) {
  position: sticky;
  left: 180px; /* 첫 번째 열 너비 */
  z-index: 30;
  background-color: rgb(255, 255, 255);

  align-items: center;
  text-align: center;
  font-weight: bold;
}

:deep() .v-data-table thead tr:nth-child(2) th:nth-child(odd) {
  font-weight: bold;
  text-align: center;
  opacity: 1 !important;
}



:deep() .v-data-table tbody td:nth-child(1) {
min-width: 180px !important;
max-width: 10px !important;
font-size: 14px;
position: sticky;
left: 0;
z-index: 2; /* 겹침 방지 */
}

:deep() .v-data-table tbody td:nth-child(2) {
min-width: 200px !important;
max-width: 100px !important;
font-size: 14px;
position: sticky;
left: 180px; /* 첫 번째 열 너비만큼 이동 */
z-index: 2;
}



/* 계획 실적 부분 */
:deep() .v-data-table thead tr:nth-child(2) th {
  top: 40px; /* 첫 번째 헤더 높이만큼 */
  align-items: center;
  text-align: center;
  font-weight: bold;
  z-index: 14;
  background-color: white;


}
/* 날짜부분 */
:deep() .v-data-table thead tr:nth-child(1) th {
  background-color: rgb(255, 255, 255);
  align-items: center;
  text-align: center;
  font-weight: bold;
  box-shadow: 
  inset 0.5px 0 0 0 rgb(214, 214, 214), /* 아래쪽 경계 */
  inset -0.5px 0 0 0 rgb(214, 214, 214), /* 아래쪽 경계 */
  inset 0 2px 0 0 rgb(228, 228, 228),
  inset 0 -2px 0 0 rgb(228, 228, 228); 

}
:deep() .v-data-table thead tr:nth-child(2) th {
  background-color: rgb(255, 255, 255);
  box-shadow: 
  inset 0.5px 0 0 0 rgb(214, 214, 214), /* 아래쪽 경계 */
  inset -0.5px 0 0 0 rgb(214, 214, 214), /* 아래쪽 경계 */
  inset 0 -2px 0 0 rgb(228, 228, 228); /* 아래쪽 경계 */
}
:deep() .part-number-header {
  font-weight: bold;
  text-align: center;

}

:deep() .v-data-table tbody td:nth-child(n+3),  
:deep() .v-data-table thead th:nth-child(n+3) {  
    min-width: 80px !important; /* 원하는 크기로 조정 */
    max-width: 115px !important;
    text-align: right;
    font-size: 13px;
}

/* ✅ Plan 데이터(아래쪽) 배경색 */
:deep() .v-data-table tbody tr td:nth-child(n+3):nth-child(odd) {
  opacity: 1 !important;
}

.select{
    width: 60px;
}

:deep() .v-data-table th,
:deep() .v-data-table td {
  margin: 0;
  padding: 0;
}

/* 날짜 부분 (첫 번째 헤더줄)의 border 제거 */
:deep() .v-data-table thead tr:nth-child(1) th {
  border: none !important;
}
.custom-text-h4 {
        font-size: 3rem !important;
        font-weight: 400;
        line-height: 2.5rem;
        text-transform: none !important;
        /* -webkit-text-stroke: 1px black; */
    }
/* row hover 효과 */
:deep() .v-data-table tbody tr:hover {
  background-color: rgb(224, 224, 224) !important; /* 연한 하늘색 */
}

.section-divider {
  border: none;
  border-top: 1px solid #000000; /* 회색 선 */
  margin: 20px 0;
  margin-top: 0px;
}
.custom-font{
    font-family: 'BebasNeue-Regular';
    font-size: 35px;
}
.bold-text {
  font-weight: bold;
}
.selected-btn {
  font-weight: bold !important;
  color: rgb(0, 0, 0) !important;
}
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.9);
  z-index: 9999;
}
.loading-container {
  display: flex;
  align-items: center;
  gap: 15px; /* 스피너와 텍스트 간격 */
}

/* ✅ 빙글빙글 도는 스피너 */
.spinner {
  width: 50px;
  height: 50px;
  border: 5px solid rgba(0, 123, 255, 0.3);
  border-top: 5px solid #007bff;
  border-radius: 50%;
  animation: spin 2s linear infinite;
}

/* ✅ 스피너 애니메이션 */
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
/* ✅ 출렁이는 색상 변화 효과 */
.loading-text {
  font-size: 64px;
  font-weight: bold;
  text-transform: uppercase;
  background: linear-gradient(120deg, #ffffff, #007bff, #ffffff);
  background-size: 200% 200%;
  -webkit-background-clip: text;
  color: transparent;
  animation: waveColor 3s ease-in-out infinite;
}

/* ✅ 출렁이는 애니메이션 */
@keyframes waveColor {
  0% {
    background-position: 0% 70%;
  }
  50% {
    background-position: 100% 30%;
  }
  100% {
    background-position: 0% 70%;
  }
}

:deep(.dp__input) {
  width: 180px;
  background-color: white !important;
  border: 2px solid #ccc;
  height: 45px;
  border-radius: 4px !important;
}
:deep(.dp__input_wrap) {
  display: flex;
  align-items: center; /* 수직 중앙 정렬 */
}


:deep(.dp__clear_icon) {
  position: absolute;
  right: 6vh; /* ✅ X 버튼을 입력 필드 안쪽으로 이동 */
  top: 50%;
  transform: translateY(-50%);
  z-index: 10; /* 다른 요소보다 위에 배치 */
}


.container-input3 {
    display: flex;
    align-items: center;
    background-color: white;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    font-size: 16px;
    width: 172px;
    height: 45px;
}

.align-right {
text-align: right;
}

.custom-card {
  max-width: 100%;  /* 원하는 최대 너비 설정 */
  width: 100%;        /* 화면 크기에 맞게 자동 조절 */
  height: 85%;
}

@font-face {
    font-family: 'HyundaiSans2';
    src: url('../../assets/fonts/HyundaiSansHeadKRMedium.woff2') format('woff2');
    font-weight: normal;
    font-style: normal;
}
@font-face {
    font-family: 'HyundaiSans';
    src: url('../../assets/fonts/HYUNDAISANSHEADKRREGULAR.TTF') format('truetype');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSans';
    src: url('../../assets/fonts/HYUNDAISANSHEADKRBOLD.TTF') format('truetype');
    font-weight: bold;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSans';
    src: url('../../assets/fonts/HYUNDAISANSHEADKRMEDIUM.TTF') format('truetype');
    font-weight: 500;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSans';
    src: url('../../assets/fonts/HYUNDAISANSHEADKRLIGHT.TTF') format('truetype');
    font-weight: 300;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSansText';
    src: url('../../assets/fonts/HYUNDAISANSTEXTKRREGULAR.TTF') format('truetype');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSansText';
    src: url('../../assets/fonts/HYUNDAISANSTEXTKRMEDIUM.TTF') format('truetype');
    font-weight: 500;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSansText';
    src: url('../../assets/fonts/HYUNDAISANSTEXTKRBOLD.TTF') format('truetype');
    font-weight: bold;
    font-style: normal;
}

@font-face {
    font-family: 'Gothic';
    src: url('../../assets/fonts/GothicA1-Bold.ttf') format('truetype');
    font-weight: bold;
    font-style: normal;
}

@font-face {
    font-family: 'hyundai2';
    src: url('../../assets/fonts/hundai-M.ttf') format('truetype');
    font-weight: bold;
    font-style: normal;
}
@font-face {
    font-family: 'hyundai';
    src: url('../../assets/fonts/hyundai-L.ttf') format('truetype');
    font-style: normal;
}

.custom-text-h4 {
    font-family: 'hyundai';
    font-weight: bold; /* 제목은 Bold */
}
/* , sans-serif */
.v-data-table {
    font-family: 'hyundai';
    font-weight: normal; /* 일반 텍스트는 Regular */
}

.v-btn {
    font-family: 'hyundai';
    font-weight: medium; /* 버튼은 Medium */
}

.v-card {
    font-family: 'hyundai';
    font-weight: normal; /* 카드 내부 텍스트는 Regular */
}



:deep() .v-table__wrapper>table>tbody>tr>td {
    border: thin solid rgba(var(--v-border-color), var(--v-border-opacity));
}



.week-range-header {
  font-size: 5px;
  line-height: 1.4;
  font-weight: bold;
  display: inline-block;
}

.container-fluid {
  height : 95%;
  overflow-y: auto;
}
:deep() .v-data-table thead th {
  background-color: #e3f2fd !important; /* 연한 파랑 */
  font-weight: bold !important;
  text-align: center !important;
}
:deep() .v-data-table tbody tr:nth-child(odd) {
  background-color: #ffffff; /* 흰색 */
}
:deep() .v-data-table tbody tr:nth-child(even) {
  background-color: #f5f5f5; /* 회색 */
}

:deep() .v-data-table tbody td {
  font-weight: 500 !important;
  text-align: center !important;
}
/* 기존의 고정 열 배경 제거 */
:deep() .v-data-table tbody td:nth-child(1),
:deep() .v-data-table tbody td:nth-child(2) {
  background-color: transparent  !important;  /* 배경색 상속받게 함 */
}

:deep() .v-data-table tbody tr:nth-child(even) td:nth-child(1),
:deep() .v-data-table tbody tr:nth-child(even) td:nth-child(2) {
  background-color: #ffffff !important; /*f5f5f5*/
}

/* 홀수 줄 흰색 + 테두리 */
:deep() .v-data-table tbody tr:nth-child(odd) td:nth-child(1),
:deep() .v-data-table tbody tr:nth-child(odd) td:nth-child(2) {
  background-color: #f0efef !important;
}

:deep() .v-data-table tbody td{
  font-weight: 500 !important;
  text-align: right !important;  /* ✅ 중앙 → 오른쪽 정렬 */
  padding-right: 12px !important; /* ✅ 숫자 간격 여유 */
}
:deep() .v-data-table tbody td:nth-child(1) {
  text-align: center !important;
  padding-right: 0 !important;
}

/* 두 번째 열(Part Name)도 가운데 정렬로 복원 */
:deep() .v-data-table tbody td:nth-child(2) {
  text-align: center !important;
  padding-right: 0 !important;
}
  </style>
  
